import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCareRecipientMemberMutationVariables = Types.Exact<{
  data: Types.UpdateCareRecipientMemberInput;
}>;


export type UpdateCareRecipientMemberMutation = { __typename?: 'Mutation', updateCareRecipientMember: { __typename?: 'OrganisationMemberUser', id: string, user: { __typename?: 'User', id: string, username: string, firstName?: string | null, lastName?: string | null, photoUrl?: string | null, info?: string | null, profile?: { __typename?: 'Profile', id: string, criticalInfo: Array<string>, positiveInfo: Array<string>, negativeInfo: Array<string> } | null } } };


export const UpdateCareRecipientMemberDocument = gql`
    mutation UpdateCareRecipientMember($data: UpdateCareRecipientMemberInput!) {
  updateCareRecipientMember(data: $data) {
    id
    user {
      id
      username
      firstName
      lastName
      photoUrl
      info
      profile {
        id
        criticalInfo
        positiveInfo
        negativeInfo
      }
    }
  }
}
    `;
export type UpdateCareRecipientMemberMutationFn = Apollo.MutationFunction<UpdateCareRecipientMemberMutation, UpdateCareRecipientMemberMutationVariables>;

/**
 * __useUpdateCareRecipientMemberMutation__
 *
 * To run a mutation, you first call `useUpdateCareRecipientMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareRecipientMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCareRecipientMemberMutation, { data, loading, error }] = useUpdateCareRecipientMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCareRecipientMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCareRecipientMemberMutation, UpdateCareRecipientMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCareRecipientMemberMutation, UpdateCareRecipientMemberMutationVariables>(UpdateCareRecipientMemberDocument, options);
      }
export type UpdateCareRecipientMemberMutationHookResult = ReturnType<typeof useUpdateCareRecipientMemberMutation>;
export type UpdateCareRecipientMemberMutationResult = Apollo.MutationResult<UpdateCareRecipientMemberMutation>;
export type UpdateCareRecipientMemberMutationOptions = Apollo.BaseMutationOptions<UpdateCareRecipientMemberMutation, UpdateCareRecipientMemberMutationVariables>;